// removed by extract-text-webpack-plugin
module.exports = {"button":"_2X2lU","wrapper":"_1tFDr","window":"CouOt","biggerMargin":"_1nCRP","text":"_3lZ71","logo":"_1wfPs","logoOverlay":"_2yQwR","backButton":"_2vL6r"};


//////////////////
// WEBPACK FOOTER
// ./src/components/home/Welcome.css
// module id = 822
// module chunks = 0